import { NgClass } from '@angular/common';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Module } from '@myapp/features/admin/models';
import { AdminService } from '@myapp/features/admin/services';
import { ControlResizerOptions, ControlResizerService } from '@mysrc/services/framework';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModulesListComponent } from '../../components/modules/modules-list/modules-list.component';
import { RoleTemplateGridComponent } from '../../components/role-templates/role-template-grid/role-template-grid.component';

@Component({
  selector: 'app-page-role-templates',
  standalone: true,
  imports: [ButtonModule, NgClass, ModulesListComponent, RoleTemplateGridComponent],
  templateUrl: './page-role-templates.component.html',
  styleUrls: ['./page-role-templates.component.scss']
})
export class PageRoleTemplatesComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  /*-------------------------- Internal properties  ---------------------------*/

  @ViewChild(ModulesListComponent)
  protected moduleListComponent!: ModulesListComponent;

  @ViewChild(RoleTemplateGridComponent)
  protected roleTemplateGridComponent!: RoleTemplateGridComponent;

  destroy$ = new Subject();

  protected height!: number;

  protected viewInit: boolean = false;

  protected afterViewInit: boolean = false;

  protected afterViewChecked: number = 0;

  public currentModuleId!: string;
  protected hideModule: boolean = false;

  /*-------------------------- Constructor  --------------------------*/

  constructor(protected adminService: AdminService
    , protected activatedRoute: ActivatedRoute
    , protected router: Router
    , protected controlResizer: ControlResizerService
    , protected cdr: ChangeDetectorRef
    , protected elem: ElementRef) {

  }

  /*----------------------------------- ng  --------------------------*/

  ngOnInit() {

    this.activatedRoute.queryParamMap.pipe(takeUntil(this.destroy$))
      .subscribe(
        (params) => {
        }
      );

    this.viewInit = true;

    this.sizeChange();
  }

  // Implemented the below as the child components do not get the opportunity
  // after view init to render themselves correctly sized to the current view

  // My original approach was to use a timer interval upon after view init but
  // Arzlan an Angular contractor with far more experience I asked to review
  // and added the detect changes code in the method below.

  // Further data review suggested it was recommended to avoid unnecessary
  // detect changes calls here so I amended with a count check to perform only
  // a certain number of times. Timing conditions could then be addressed if
  // two calls are not sufficient.

  ngAfterViewChecked(): void {

    // The below seeks to reduce the number of calls made to detect changes

    if (this.viewInit && this.afterViewInit && this.afterViewChecked < 2) {

      // We only want to do this as few times as possible so that upon the initial display of the component
      // we have the opportunity to render all the components to fit the current viewport
      this.afterViewChecked++;

      this.sizeChange();

      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    this.afterViewInit = true;

    this.moduleListComponent.Initialized();

  }

  ngOnDestroy() {

    this.destroy$.next();
    this.destroy$.complete();
  }

  /*--------------------------- event handlers  --------------------------*/

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.sizeChange();
  }

  protected onLicensesClick() {
    this.router.navigate(['./admin/license']);
  }

  protected onModuleSelected(ev: Module | null) {
    if (ev?.id) {
      this.currentModuleId = ev.id;
    }
  }

  protected onModulesLoaded(count: number | null) {
    let v = !!(count) ? (count < 2) : true;

    this.hideModule = v;
  }

  /*--------------------------- internal functions  --------------------------*/

  protected sizeChange() {

    if (this.viewInit) {
      var options: ControlResizerOptions = new ControlResizerOptions();
      options.offsetTopHeight = 54;
      options.offsetBottomHeight = 21;

      this.height = this.controlResizer.calculateHeight(options);

      options.offsetTopHeight = 6;
      options.offsetBottomHeight = 29;

    }
  }


}
